import React, { useEffect, useState } from 'react';
import { getArchivoView, isVideoContentType } from '../services/archivoService';

interface ArchivoMediaProps {
  archivoId: number;
  contentType?: string;
  className?: string;
  alt?: string;
}

const ArchivoMedia: React.FC<ArchivoMediaProps> = ({ archivoId, contentType, className, alt }) => {
  const [url, setUrl] = useState<string | null>(null);
  const [resolvedType, setResolvedType] = useState(contentType || '');
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoke: (() => void) | undefined;
    let cancelled = false;
    getArchivoView(archivoId)
      .then((view) => {
        if (cancelled) {
          view.revoke?.();
          return;
        }
        revoke = view.revoke;
        setUrl(view.url);
        setResolvedType(view.contentType || contentType || '');
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
      revoke?.();
    };
  }, [archivoId, contentType]);

  if (error) {
    return <span className="text-sm text-gray-500 dark:text-gray-400">No se pudo cargar</span>;
  }
  if (!url) {
    return <span className="text-sm text-gray-400">Cargando…</span>;
  }

  if (isVideoContentType(resolvedType)) {
    return (
      <video controls className={className || 'max-h-64 rounded'} src={url}>
        {alt}
      </video>
    );
  }

  return (
    <img
      src={url}
      alt={alt || 'Adjunto'}
      className={className || 'max-h-64 rounded object-contain'}
    />
  );
};

export default ArchivoMedia;
